import axios from "axios";
import { handleAPIError, handleAPISuccess } from "./utils/utilsAPI";
import { downloadInvoiceValidation } from "./utils/validateAPI";
import { INVOICE_URL, REPORT_URL, TEST_URL } from "./constant";
import store from "../store";
import {
  errToast,
  failureToast,
  successToast,
  warningToast,
} from "../store/dbFilter/actions";

const token = "8lQzN922rpRDaMbh3m5J";

const apiInvoice = axios.create({
  baseURL: `${TEST_URL}/invoice`,
});

const apiReport = axios.create({
  baseURL: `${TEST_URL}/reports`,
  //  baseURL:  `${REPORT_URL}`,
});
// download invoice
const downloadInvoiceInPDF = async (invoiceDetails) => {
  const payload = { token: token, ...invoiceDetails };
  try {
    await downloadInvoiceValidation.validate(payload);
    const response = await apiInvoice.post(`/downloadInvoice`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
    });

    // return handleAPISuccess(res);
    if (response.status !== 200) {
      // throw new Error(`Error downloading the Invoice: ${response.statusText}`);
      store.dispatch(
        failureToast({
          title: "Error",
          message: "Error downloading the Invoice.",
        })
      );
    }

    if (response.data instanceof Blob) {
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "invoice.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      store.dispatch(
        successToast({
          title: "Success!",
          message: "Invoice downloaded Successfully",
        })
      );
    } else {
      // throw new Error("Received invalid file data.");
      store.dispatch(
        errToast({ title: "Error", message: "Received invalid file data." })
      );
    }
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

// mail invoice
const mailInvoicePDF = async (invoiceDetails) => {
  const payload = { token: token, ...invoiceDetails };
  try {
    await downloadInvoiceValidation.validate(payload);
    const response = await apiInvoice.post(`/mailInvoice`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
    });

    // return handleAPISuccess(res);
    if (response.status === 201) {
      // throw new Error(`Error downloading the Invoice: ${response.statusText}`);
      store.dispatch(
        successToast({
          title: "Success!",
          message: "Invoice Sent in Mail Successfully",
        })
      );
    }else{
      store.dispatch(
        errToast({ title: "Error", message: "Failed to send Mail. try after sometime..." })
      );
    }
    //     else if(res)
    // "message": "sent invoice via mail",
    console.log("mail response : ", response);
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

// download report pdf
const downloadReportInPDF = async (reportDetails) => {
  const payload = { token: token, ...reportDetails };
  try {
    // await downloadInvoiceValidation.validate(payload);
    const response = await apiReport.post(`/downloadReport`, reportDetails, {
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
    });
    // console.warn("response from the downloadReportInPDF : ",response);

    // return handleAPISuccess(res);
    if (response.status === 200) {
      // throw new Error(`Error downloading the Invoice: ${response.statusText}`);
      if (response.data instanceof Blob) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "report.pdf");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        store.dispatch(
          successToast({
            title: "Success!",
            message: "Report downloaded Successfully",
          })
        );
      } else {
        // throw new Error("Received invalid file data.");
        store.dispatch(
          errToast({ title: "Error", message: "Received invalid file data." })
        );
      }
    } else if (response.status === 204) {
      store.dispatch(
        warningToast({
          title: "No data",
          message: "There is no data to generate the Report",
        })
      );
    } else {
      store.dispatch(
        failureToast({
          title: "Error",
          message: "Error downloading the Report.",
        })
      );
    }
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};
export { downloadInvoiceInPDF, downloadReportInPDF, mailInvoicePDF };
